<template>
  <div id="app">
  <!--Display the Navbar at the top--->  
  <Navbar />
    <router-view/>
  </div>
</template>

<script>
import Navbar from '@/components/layout/Navbar'
export default {
  name: 'App',
  components: {
    Navbar
  }
}
</script>

<style>
/********Styling the background body of the DOM to a light grey***********/
body {
  background: linear-gradient(rgba(255,255,255,0.1),rgba(255,255,255,0.3)),
    url(images/achievement-adult-business-1243524.png)center/cover fixed no-repeat; 
    font-family: 'Mukta Mahee', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue